// extracted by mini-css-extract-plugin
export default {"up":"up_up__sFuml","upAr":"up_upAr__ajmPJ","Shimiring":"up_Shimiring__7dHZZ"};